<template>
  <div class="employee-fair-pay-menu">
    <HorizontalMenu
      :items="items"
      :value="value"
      size="small"
      :bottom-line="false"
      @onChange="handleOnChange"
    />
  </div>
</template>

<script setup>
import HorizontalMenu from "@components/HorizontalMenu/HorizontalMenu.vue";
import {
  EMPLOYEE_FAIR_PAY_MENU_ITEMS,
  EMPLOYEE_FAIR_PAY_TAB,
} from "./employeeFairPayMenuConstants";

defineProps({
  items: {
    type: Array,
    default: () => EMPLOYEE_FAIR_PAY_MENU_ITEMS,
  },
  value: {
    type: Number,
    default: EMPLOYEE_FAIR_PAY_TAB.PAY_PLANS,
  },
});

const emit = defineEmits(["onChange", "input"]);

function handleOnChange(index) {
  emit("onChange", index);
  emit("input", index);
}
</script>

<style scoped>
.employee-fair-pay-menu {
  width: 100%;
  padding: 0 10px;
  border-bottom: 1px solid #f0f0f0;
  box-sizing: border-box;
}

::v-deep .employee-fair-pay-menu .horizontal-small-tab.horizontal-tab .v-tabs-slider-wrapper {
  bottom: 0 !important;
}

::v-deep .employee-fair-pay-menu .horizontal-small-tab .menu-tabs {
  height: 32px;
  min-width: auto !important;
  padding: 4px 4px 12px !important;
  margin-right: 12px !important;
  margin-bottom: 0 !important;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

::v-deep .employee-fair-pay-menu .horizontal-small-tab .menu-tabs:last-child {
  margin-right: 0 !important;
}
</style>
